/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nav_Ndamanagement2Inputs */

const en_coinvestments_nav_ndamanagement2 = /** @type {(inputs: Coinvestments_Nav_Ndamanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA Management`)
};

/**
* | output |
* | --- |
* | "NDA Management" |
*
* @param {Coinvestments_Nav_Ndamanagement2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nav_ndamanagement2 = /** @type {((inputs?: Coinvestments_Nav_Ndamanagement2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nav_Ndamanagement2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nav_ndamanagement2(inputs)
});
export { coinvestments_nav_ndamanagement2 as "coInvestments_nav_ndaManagement" }